import { render, staticRenderFns } from "./SegSolicitudPrincipal.vue?vue&type=template&id=222bda19&scoped=true&"
import script from "./SegSolicitudPrincipal.vue?vue&type=script&lang=js&"
export * from "./SegSolicitudPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./SegSolicitudPrincipal.vue?vue&type=style&index=0&id=222bda19&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222bda19",
  null
  
)

export default component.exports